import Global  from '@/scripts/Global';
import VueSignals from '@/scripts/VueSignals';

export default {
    data() {
        return {
            crt: null, // Ghost of drag
        }
    },
    methods: {
        // Start Drag Functions //

        // These 2 functions have to be added to the element as
        // draggable="true" v-on:dragstart="dragHandler($event, item)"
        // v-on:dragend="dragEndHandler($event)"

        dragHandler(ev, item) {
           // make it half transparent
           ev.target.style.opacity = 0.3;
           // Drag ghost
           this.crt = ev.target.cloneNode(true);
           this.crt.style.opacity = 1;
           this.crt.style.position = 'absolute';
           //Give the ghost the same width as the dragged element
           this.crt.style.width = `${ev.target.offsetWidth}px`;
           document.body.appendChild(this.crt);
           ev.dataTransfer.setDragImage(this.crt, 0, 0);

            let data = {
                "ff_id": item.cp_id,
                "ff_name": item.name,
                "ff_type": item.type
            };
            let jsonString = JSON.stringify(data);
            ev.dataTransfer.setData("text", jsonString);
        },

        dragEndHandler(ev) {
            // reset the transparency
            ev.target.style.opacity = "";

            //Drag ghost dissapear
            if (this.crt) {
                this.crt.style.display = 'none';
            }

            // Bad approach
            document.getElementById('message_input').style.border = '';
        },

        userDragHandler(ev, user) {
            // make it half transparent
            ev.target.style.opacity = 0.3;

            let data = {
                "user_id": user.user_id,
                "user_name": user.username,
                "ff_type": 'user'
            };
            let jsonString = JSON.stringify(data);
            ev.dataTransfer.setData("text", jsonString);
        },

        // End Drag Functions //
        // Start Drop Function //
        // Added as
        // v-on:drop="drop($event, dropzone_id)" v-on:dragover="allowDrop($event, dropzone_id)"
        // v-on:dragenter="dragEnterHandler($event, dropzone_id)" v-on:dragleave="dragLeaveHandler($event, dropzone_id)"
        allowDrop(ev) {
            ev.preventDefault();
        },
        drop(ev, element_id) {
            // When drop change the border
            document.getElementById('message_input').style.border = '';

            ev.preventDefault();
            let data = JSON.parse(ev.dataTransfer.getData("text"));
            if (data.ff_type == 'file' || data.ff_type == 'folder') {
                Global.globalValue(VueSignals.DRAG_DROP_FILE_MENTION, data)
            }

            if (data.ff_type == 'user') {
                Global.globalValue(VueSignals.DRAG_DROP_USER_MENTION, data)
            }
        },
        dragEnterHandler(ev, element_id) {
            // When the drag enters change the border
            document.getElementById('message_input').style.border = "2px solid #4b95ff";
        },

        dragLeaveHandler(ev, element_id) {
            // When the drag leaves change the border
            if (!document.getElementById('message_input').contains(ev.target)) {
                // If its not an child element of the message input
                ev.target.style.border = "";
            }
        }
        // End Drop Funtions
    }
}
